import React, { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";

import { FaUser, FaQuestion } from "react-icons/fa6";
import { ImBullhorn } from "react-icons/im";
// import heroImg from './../../assets/images/banner/hero-slider.png'
import heroImg from './../../assets/images/banner/ghibli-hero-slider.png'
import machine0 from './../../assets/images/banner/machine-img.png'
import machine1 from './../../assets/images/banner/machine-img-2.png'

function HeroSlider() {

    const [isOpen, setIsOpen] = useState(false); // FOR FIXED BUTTON 

    // ---------------------------------------------------------
    //             Take a Tour Video Modal Code (START) 
    // ---------------------------------------------------------

    const [show, setShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [videoTitle, setVideoTitle] = useState("");
    const handleShow = (url, title) => {
        setVideoUrl(url);
        setVideoTitle(title);
        setShow(true);
    };
    const handleCloseBtn = () => {
        setShow(false);
        setVideoUrl("");
        setVideoTitle("")
    };

    // ---------------------------------------------------------
    //             Take a Tour Video Modal Code (END) 
    // ---------------------------------------------------------


    function handler() {
        setIsOpen(!isOpen); // Toggle Button
        handleShow("https://api.dyntube.com/v1/apps/hls/zqAujAig0qiIaSBFSJVQ.m3u8", "Take a Tour");
    }

    return (
        <>

            <section className='hero-slider'>

                <div className={`fx-side-btn d-md-none ${isOpen ? 'show-fx-btn' : ' '}`} onClick={() => { handler() }}><a href='#'><ImBullhorn />Take a Tour</a></div>

                <img className='f-left' src={machine0} alt="machine image" loading="lazy" />
                <img className='f-right' src={machine1} alt="machine image" loading="lazy" />


                <div className='container'>
                    <div className='row position-relative'>
                        <div className='col-md-7'>
                            {/* <h1 className='hd-1'>अपने व्यवसाय को नई ऊंचाइयों  <br />तक पहुँचाएँ!</h1> */}
                            <h1 className='hd-1 mb-0'>उत्तर प्रदेश में <span className='' style={{ color: "#f6bd60" }}>MSME</span> आपूर्तिकर्ताओं (Suppliers)< br/> या फ्रेंचाइज़ी (Franchise)  के लिए < br/><span className='' style={{ color: "#f6bd60" }}>वन-स्टॉप प्लेटफॉर्म</span> </h1>
                            {/* <h3 className='hd-2 text-white'>  <span className='' style={{ color: "#f6bd60" }}>MSME</span></h3> */}
                            {/* <p className='desc-1'>CMYuva योजना में Supplier(आपूर्तिकर्ता) या Franchise(फ्रेंचाइज़ी) के रूप में पंजीकरण करें</p> */}

                            <div className="mt-md-4 d-flex justify-content-md-start justify-content-center" style={{ position: 'relative', zIndex: '100' }}>

                                <a
                                    type="button"
                                    className="round-btn ro-btn-white "
                                    href='/Register'
                                >
                                    <span><FaUser /></span>
                                    Register Now
                                    {/* अभी पंजीकरण करें */}
                                </a>

                                <a
                                    type="button"
                                    className="round-btn ro-btn-theme mx-2 "
                                    href='#FAQ-Section'

                                >
                                    <span><FaQuestion /></span>FAQ's

                                </a>

                                {/* <a
                                    type="button"
                                    className="round-btn ro-btn-theme"
                                    // onClick={() =>
                                    //     handleShow("https://api.dyntube.com/v1/apps/hls/zqAujAig0qiIaSBFSJVQ.m3u8", "Take a Tour")}
                                >
                                    <span><FaQuestion /></span>Download brochure

                                </a> */}

                            </div>
                        </div>
                        <div className='col-md-5 col-sm-6 col-7 mx-auto mt-4 mt-md-0 d-flex justify-content-center' style={{ overflow: "hidden" }}>
                            <img className='side-img img-fluid' src={heroImg} alt="CM Yuva Slider" loading="lazy" />
                            <span className='bg-overlay'></span>
                        </div>
                    </div>
                </div>

            </section>

            {/* ---------------------------------------------------------
                        Take a Tour (MODAL)
            --------------------------------------------------------- */}

            <Modal
                show={show}
                backdrop="static"
                keyboard={false}
                onHide={handleCloseBtn}
                centered
                className="video-modal"
                animation={false}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="video-frame">
                        <ReactPlayer
                            className="react-player"
                            url={videoUrl || ""}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={show}
                        />
                    </div>
                </Modal.Body>
            </Modal>

        </>

    )
}

export default HeroSlider
